// Thematic imagery for HITECH GROUP website
// Abstract, geometric, minimal imagery matching Nordic corporate aesthetic
// Colors: Navy #2B3A4D, Slate #6B7B8C, Electric Blue #0066CC
// ALL images must be in blue/navy tones only

// Note: SVG images are now provided via ITThematicImages component
// These URLs serve as fallbacks or background images

export const images = {
  hero: {
    // Clean dark blue gradient
    background: 'https://images.unsplash.com/photo-1557683316-973673baf926?w=1920&q=80',
    // Darker blue fallback
    fallback: 'https://images.unsplash.com/photo-1557683304-673a23048d34?w=1920&q=80',
  },
  services: {
    // IT Consulting - using SVG from ITThematicImages
    consulting: 'it-consulting-svg',
    // Cloud Infrastructure - using SVG from ITThematicImages
    cloud: 'cloud-infrastructure-svg',
    // Data Analytics - using SVG from ITThematicImages
    data: 'data-analytics-svg',
    // Software Development - using SVG from ITThematicImages
    software: 'software-development-svg',
  },
  about: {
    // Blue gradient abstract
    connectivity: 'https://images.unsplash.com/photo-1557683316-973673baf926?w=1200&q=80',
    // Navy gradient abstract
    abstract: 'https://images.unsplash.com/photo-1557683304-673a23048d34?w=1200&q=80',
  },
  approach: {
    // Dark blue abstract
    process: 'https://images.unsplash.com/photo-1557683304-673a23048d34?w=1600&q=80',
  },
  patterns: {
    // Blue gradient
    grid: 'https://images.unsplash.com/photo-1557683316-973673baf926?w=1920&q=80',
    // Dark gradient
    geometric: 'https://images.unsplash.com/photo-1557683304-673a23048d34?w=1920&q=80',
  },
  // AI Concierge – hotel & tech, blue/navy tones
  aiConcierge: {
    problem: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1200&q=80',
    beforeAfter: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=1200&q=80',
    howItWorks: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=1200&q=80',
    integration: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&q=80',
    journey: 'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=1200&q=80',
    security: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=1200&q=80',
  },
};

export default images;
